import React, { useEffect, useState } from "react";
import { Form, Row, Col, Spinner, Container } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faUserPlus } from "@fortawesome/free-solid-svg-icons";
import { useParams, useNavigate } from "react-router-dom";
import API from "../../api/axiosConfig";

import Title from "../../components/title";
import RegisterTextbox from "../../components/RegisterTextBox";
import RegisterSelect from "../../components/RegisterSelect";
import RegisterRadio from "../../components/Radio";
import UploadInput from "../../components/UploadInput";
import CustomButton from "../../components/CustomButton";
import SwitchComponent from "../../components/SwitchComponent/SwitchComponent.js";

function EditEmployee() {
  const { id, startingTab } = useParams();
  const navigate = useNavigate();

  const [employeeData, setEmployeeData] = useState(null);
  const [salaryDetails, setSalaryDetails] = useState({
    mainBudget: "",
    socialWelfare: "",
    mobnum: "",
  });
  const [error, setError] = useState({});
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [rows, setRows] = useState([]);
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [iban, setIban] = useState("");
  const [address, setAddress] = useState("");
  const [nationality, setNationality] = useState("");
  const [qualification, setQualification] = useState("");
  const [dob, setDob] = useState(new Date().toISOString().substr(0, 10));
  const [workDate, setWorkDate] = useState(
    new Date().toISOString().substr(0, 10)
  );
  const [status, setStatus] = useState(0);
  const [idexpireDate, setIdexpireDate] = useState(
    new Date().toISOString().substr(0, 10)
  );
  const [jobtitle, setJobtitle] = useState("");
  const [idtype, setIdtype] = useState(0);
  const [idnumber, setIdnumber] = useState("");
  const [gender, setGender] = useState(0);
  const [expirehire, setExpirehire] = useState(
    new Date().toISOString().substr(0, 10)
  );
  const [upload, setUpload] = useState(null);
  const [empid, setEmpid] = useState("");
  const [employeestate, setEmployeestate] = useState(true);

  // Get Job Titles
  useEffect(() => {
    const fetchJobTitles = async () => {
      try {
        const res = await API.post("/jobtitle");
        if (res.status === 200) setRows(res.data);
      } catch (err) {
        console.error(err);
      }
    };
    fetchJobTitles();
  }, []);

  // Get Employee Data
  useEffect(() => {
    const getEmployeeData = async () => {
      try {
        const res = await API.get(`employees/${id}`);
        if (res.status === 200) setEmployeeData(res.data);
      } catch (err) {
        console.error(err);
      }
    };
    getEmployeeData();
  }, [id]);

  useEffect(() => {
    if (employeeData) {
      setEmpid(employeeData.id);
      setName(employeeData.name || "");
      setEmail(employeeData.email || "");
      setIban(employeeData.ibannumber || "");
      setAddress(employeeData.address || "");
      setNationality(employeeData.nationality || "");
      setQualification(employeeData.qualification || "");
      setDob(employeeData.dateofbirth?.substr(0, 10) || dob);
      setWorkDate(employeeData.dateofhire?.substr(0, 10) || workDate);
      setStatus(employeeData.socialstatus || 0);
      setIdexpireDate(
        employeeData.nationalid_expire?.substr(0, 10) || idexpireDate
      );
      setJobtitle(employeeData.jobtitle?.id || "");
      setIdtype(employeeData.nationalid_type || 0);
      setIdnumber(employeeData.nationalid || "");
      setGender(employeeData.gender || 0);
      setExpirehire(
        employeeData.contractexpiration?.substr(0, 10) || expirehire
      );
      setSalaryDetails({
        mainBudget: employeeData.salary?.basic || "",
        socialWelfare: employeeData.salary?.socialinsurance || "",
        mobnum: employeeData.phone || "",
      });
    }
  }, [employeeData]);

  const handleSalaryChange = (e) => {
    const { id, value } = e.target;
    setSalaryDetails((prev) => ({ ...prev, [id]: value }));
  };

  const handleUpdateEmployee = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);
    const mFormData = new FormData();

    mFormData.append("id", empid);
    mFormData.append("name", name);
    mFormData.append("email", email);
    mFormData.append("iban", iban);
    mFormData.append("address", address);
    mFormData.append("nationality", nationality);
    mFormData.append("qualification", qualification);
    mFormData.append("dob", dob);
    mFormData.append("workdate", workDate);
    mFormData.append("status", status);
    mFormData.append("idexpiredate", idexpireDate);
    mFormData.append("jobtitle", jobtitle);
    mFormData.append("idtype", idtype);
    mFormData.append("idnumber", idnumber);
    mFormData.append("gender", gender);
    mFormData.append("contractexpiration", expirehire);
    mFormData.append("phone", salaryDetails.mobnum);
    mFormData.append("basic", salaryDetails.mainBudget);
    mFormData.append("socialinsurance", salaryDetails.socialWelfare);
    if (upload) mFormData.append("upload", upload);

    try {
      const res = await API.post("/employees/update", mFormData, {
        headers: { "Content-Type": "multipart/form-data" },
      });
      if (res.status === 200) navigate("/hrreport/employees");
    } catch (err) {
      console.error(err);
      setError(err.response?.data?.errors || {});
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <Container className="py-3">
      <Title
        title={`${name} - تعديل`}
        className="marketingtitle text-center mb-4"
        icon={<FontAwesomeIcon icon={faUserPlus} />}
      />

      <Form onSubmit={handleUpdateEmployee}>
        {/* ===== بيانات عامة ===== */}
        <Row className="mb-3 justify-content-evenly">
          <Col md={4}>
            <RegisterTextbox
              id="empname"
              label="إسم الموظف"
              type="text"
              value={name}
              onChange={(e) => setName(e.target.value)}
            />
            {error.name && (
              <div className="text-danger small">{error.name}</div>
            )}
          </Col>

          <Col md={4}>
            <p className="datelable">تاريخ الميلاد</p>{" "}
            <input
              type="date"
              id="date"
              onChange={(e) => setDob(e.target.value)}
              value={dob}
              className="custom-datepicker"
              style={{ width: "100%", height: "42px" }}
            />{" "}
            {error && error.dob && (
              <div
                style={{
                  color: "red",
                  fontSize: "12px",
                  marginTop: "5px",
                  marginBottom: "5px",
                }}
              >
                {" "}
                {error.dob}{" "}
              </div>
            )}
          </Col>
        </Row>

        <Row className="mb-3 justify-content-evenly">
          <Col md={4}>
            <p className="datelable">تاريخ الإلتحاق بالعمل</p>{" "}
            <input
              type="date"
              id="date"
              onChange={(e) => setWorkDate(e.target.value)}
              value={workDate}
              className="custom-datepicker"
              style={{ width: "100%", height: "42px" }}
            />{" "}
            {error && error.workDate && (
              <div
                style={{
                  color: "red",
                  fontSize: "12px",
                  marginTop: "5px",
                  marginBottom: "5px",
                }}
              >
                {" "}
                {error.workDate}{" "}
              </div>
            )}
          </Col>

          <Col md={4}>
            <p className="datelable">تاريخ انتهاء التعاقد</p>{" "}
            <input
              type="date"
              id="date"
              onChange={(e) => setExpirehire(e.target.value)}
              value={expirehire}
              className="custom-datepicker"
              style={{ width: "100%", height: "42px" }}
            />{" "}
            {error && error.expirehire && (
              <div
                style={{
                  color: "red",
                  fontSize: "12px",
                  marginTop: "5px",
                  marginBottom: "5px",
                }}
              >
                {" "}
                {error.expirehire}{" "}
              </div>
            )}
          </Col>
        </Row>

        <Row className="mb-3 justify-content-evenly">
          <Col md={4}>
            <RegisterSelect
              id="status"
              label="الحالة الإجتماعية"
              options={[
                { value: "", label: "اختر الحالة الاجتماعية" },
                { value: 1, label: "متزوج" },
                { value: 2, label: "أرمل" },
                { value: 3, label: "مطلق" },
                { value: 4, label: "اعزب" },
              ]}
              value={status}
              onChange={(e) => setStatus(e.target.value)}
            />
          </Col>

          <Col md={4}>
            <Form.Group>
              <Form.Label className="w-100 text-end">الجنس</Form.Label>
              <div
                className="d-flex justify-content-evenly pt-2 ps-2"
                style={{
                  border: "3px solid var(--border-color)",
                  borderRadius: "28px",
                  height: "42px",
                  fontSize: "14px",
                }}
              >
                <RegisterRadio
                  label="ذكر"
                  name="gender"
                  value={0}
                  checked={gender === 0}
                  onChange={() => setGender(0)}
                />
                <RegisterRadio
                  label="أنثي"
                  name="gender"
                  value={1}
                  checked={gender === 1}
                  onChange={() => setGender(1)}
                />
              </div>
            </Form.Group>
          </Col>
        </Row>

        {/* ===== بيانات الهوية ===== */}
        <Row className="mb-3 justify-content-evenly">
          <Col md={4}>
            <RegisterSelect
              id="idtype"
              label="نوع الهوية"
              options={[
                { value: "", label: "اختر نوع الهوية" },
                { value: 1, label: "رقم الهوية" },
                { value: 2, label: "رقم الاقامة" },
              ]}
              value={idtype}
              onChange={(e) => setIdtype(e.target.value)}
            />
          </Col>

          <Col md={4}>
            <RegisterTextbox
              id="idnumber"
              label="الرقم"
              type="text"
              value={idnumber}
              onChange={(e) => setIdnumber(e.target.value)}
            />
          </Col>
        </Row>

        {/* ===== بيانات التواصل ===== */}
        <Row className="mb-3 justify-content-evenly">
          <Col md={4}>
            <RegisterTextbox
              id="mobnum"
              label="رقم الجوال"
              type="number"
              value={salaryDetails.mobnum}
              onChange={(e) =>
                setSalaryDetails((prev) => ({
                  ...prev,
                  mobnum: e.target.value,
                }))
              }
            />
          </Col>
          <Col md={4}>
            <RegisterTextbox
              id="iban"
              label="رقم IBAN"
              type="text"
              value={iban}
              onChange={(e) => setIban(e.target.value)}
            />
          </Col>
        </Row>

        {/* ===== بيانات الراتب ===== */}
        <Row className="mb-3 justify-content-evenly">
          <Col md={4}>
            <RegisterTextbox
              id="mainBudget"
              label="الراتب الأساسي"
              type="number"
              value={salaryDetails.mainBudget}
              onChange={handleSalaryChange}
            />
          </Col>
          <Col md={4}>
            <RegisterTextbox
              id="socialWelfare"
              label="التأمين الإجتماعي"
              type="number"
              value={salaryDetails.socialWelfare}
              onChange={handleSalaryChange}
            />
          </Col>
        </Row>

        {/* ===== بيانات أخرى ===== */}
        <Row className="mb-3 justify-content-evenly">
          <Col md={4}>
            <RegisterTextbox
              id="empemail"
              label="البريد الإلكتروني"
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
            />
          </Col>
          <Col md={4}>
            <RegisterTextbox
              id="empname"
              label="الجنسية"
              type="text"
              value={nationality}
              onChange={(e) => setNationality(e.target.value)}
            />
          </Col>
        </Row>

        <Row className="mb-3 justify-content-evenly">
          <Col md={4}>
            <RegisterSelect
              id="jobtitle"
              label="المسمى الوظيفي"
              options={[
                { value: "", label: "اختر المسمى الوظيفي" },
                ...rows.map((r) => ({ value: r.id, label: r.title })),
              ]}
              value={jobtitle}
              onChange={(e) => setJobtitle(e.target.value)}
            />
          </Col>
          <Col md={4}>
            <RegisterTextbox
              id="degree"
              label="المؤهل"
              type="text"
              value={qualification}
              onChange={(e) => setQualification(e.target.value)}
            />
          </Col>
        </Row>
        <Row className="mb-3 justify-content-evenly">
          <Col
            md={4}
            className="p-2 d-flex justify-content-between"
          >
          </Col>
          <Col
            md={4}
            className="p-2 d-flex justify-content-between"
          >
            <SwitchComponent  checked={employeestate} setChecked={setEmployeestate} />
            <div>حالة الموظف</div>
          </Col>
        </Row>

        <Row className="mb-3 mx-auto p-4 justify-content-center upload-image">
          {upload && (
            <div className="image p-0">
              <img src={URL.createObjectURL(upload)} alt="صورة مرفوعة" />
            </div>
          )}
          <div style={{ marginTop: "10px" }}>
            <UploadInput
              id="empdocumentUpload"
              label="رفع الصورة الشخصية"
              onChange={(e) => setUpload(e.target.files[0])}
              accept="image/*"
            />
          </div>
        </Row>
        {/* ===== زر الحفظ ===== */}
        <Row>
          <Col className="text-center">
            {isSubmitting ? (
              <Spinner animation="border" variant="primary" />
            ) : (
              <CustomButton type="submit" text="حفظ" />
            )}
          </Col>
        </Row>
      </Form>
    </Container>
  );
}

export default EditEmployee;
